import {Component} from '@angular/core';
import {UrlService} from '../../../services/url.service';
import {ParkingPassService} from '../../../services/parking-pass.service';
import { AuthenticationService } from '../../../services/authentication.service';
import {ApiClientService} from '../../../services/api-client.service';

declare const toastr: any;
declare const $: any;
declare const moment: any;

@Component({
    selector: 'parking-pass-list',
    templateUrl: './parking-pass-list.component.html',
    styleUrls: ['./parking-pass-list.component.scss']
})
export class ParkingPassListComponent {

    constructor(
        public urlService: UrlService,
        public api: ApiClientService,
        public parkingPassService: ParkingPassService,
        public authenticationService: AuthenticationService
    ) {}

    orderBy(orderBy: string, $event) {
        if (this.parkingPassService.data.allParkingPasses.total < 2) return;
        this.urlService.orderBy(orderBy, $event);
    }

    showPaymentModal(booking) {
        this.parkingPassService.showPaymentModal(booking);
    }

    bookingHasPayments(item): boolean {
        return item.payment ? true : false;
    }

    getPassTypesStringForBooking(booking): string {
        let passTypes = [];

        if(booking.bookingPassTypes) {
            booking.bookingPassTypes.filter(bookingPassType => {
                const index = passTypes.findIndex(pt => pt.name == bookingPassType.passTypeName);
                if(index == -1)
                    passTypes.push({name: bookingPassType.passTypeName, count: 1});
                else
                    passTypes[index].count++;
            });
        }

        let passTypeString = '';

        passTypes.forEach(pt => {
            passTypeString += `${pt.name} (${pt.count}), `;
        });
        return passTypeString ? passTypeString.slice(0, -2) : passTypeString;
    }

    showArrowButton(item): boolean {
        return (item.isCanDelete && !this.authenticationService.userIsResident) ||
               !((!item.isCanEdit || this.parkingPassService.isBookingDateLaterThanCurrent(item) ||
               !(item.status == 'approved' && !this.parkingPassService.isBookingStartDateLessThanCurrent(item))) &&
               !(item.isCanEdit && item.status == 'pending' && this.parkingPassService.isBookingDateLaterThanCurrent(item))) || item.status != 'pending';
    }

    firstButton(item) {
        if(item.isCanEdit && (item.status == 'approved' || item.status == 'declined'))
            return 'edit';
        else if(item.isCanApprove && item.approvalRequired && item.status == 'pending')
            return 'approve';
        else
            return 'view';
    }

    isOnlyOneLotExists() {
        let uniqueLots = [];
        this.parkingPassService.buildingsForRead.forEach(building => {
            building.parkingLots.forEach(lot => {
                if(uniqueLots.indexOf(lot) == -1)
                    uniqueLots.push(lot);
            });
        });
        return uniqueLots.length === 1;
    }

    showHint(e) {
        const $td = $(e.target).closest('.table-hint-td');
        if ($td.hasClass('active'))
            $td.removeClass('active');
        else {
            $('.table-hint-td').removeClass('active');
            $td.addClass('active');
        }
    }

    toggleCheck(selectedItem): void {
        const checked = selectedItem.checked;
        this.parkingPassService.data.allParkingPasses.data.forEach(item => item.checked = false);
        if (checked && this.parkingPassService.selectedItemData) {
            this.parkingPassService.selectedItemData = null;
            this.parkingPassService.toggleDetailedView(null, false);
            selectedItem.checked = false;
        } else {
            this.parkingPassService.selectedItemData = selectedItem;
            selectedItem.checked = true;
            this.parkingPassService.toggleDetailedView(selectedItem, true);
        }
    }
}



// WEBPACK FOOTER //
// /app/src/app/views/parking-pass/parking-pass-list/parking-pass-list.component.ts